// extracted by mini-css-extract-plugin
export default {"templatesPage":"wl0EVp","templates":"wWBT0v","searchFadeIn":"yDn79q"};